import React from 'react';
import '../../styles/Header.scss';
import Button from './Button.jsx';
import Documents from '../Documents/List';
import Settings from '../Videoconference/Settings';


import { Modal, ModalProgress, ModalConfirm, ModalConfirm2 } from './Modal';


export default class Header extends React.Component {

    state = {
        confirmLogout: false,
        modal: false,
        menuToggled: false,
        chatDisplayed: false
    }

    async componentDidMount() {
        window.sdk.event().on('newMessage', () => {
            this.forceUpdate();
          })
      
          window.sdk.event().on('deleteMessage', () => {
            this.forceUpdate();
          })

          window.sdk.event().on('openHeaderModal', (section) => {
            this.setState({
                modal:section
            })
          })

          window.sdk.event().on('toggleChat', () => {	
            this.setState({
                chatDisplayed: !this.state.chatDisplayed
            })
          })
    }

    logout = () => {
        window.sdk.exit();
        window.close();
    }
    showModal(section){
        this.setState({
            menuToggled: false,
            modal:section
        })
    }
    toggleLogoutConfirm = () => {
        this.setState({
            confirmLogout:!this.state.confirmLogout
        })
    }

    toggleMedicalInfo = () => {
        window.sdk.event().emit('toggleMedicalInfo');
    }

    actionBack = () => {
        if(this.state.modal != false){
            this.showModal(false);
        }
        else if(this.state.chatDisplayed == true){
            window.sdk.event().emit('toggleChat')
        }
    }

    render() {
        const { menuToggled } = this.state;
        const displayIcons = !this.props.noIcons;

        let count = window.sdk.chat().getNbDocument();
        return (
            <header className={`${ menuToggled ? 'menu--opened' : '' }`}>
                <div className="header-left">
                    {displayIcons && (<React.Fragment>
                        {(this.state.chatDisplayed || this.state.modal != false) && <div className="back-wrapper" onClick={this.actionBack}>
                            <i className="icon-back"></i>
                        </div>}
                    </React.Fragment>)}
                </div>
                <div className="logo">
                    <div className="logo__inner"></div>
                </div>
                <div className="header-right btn-list">
                    {displayIcons && (<React.Fragment>
                        <button className="header-toggle" onClick={() => this.setState({ menuToggled: !menuToggled })}>
                            <i className="icon-hamburger"></i>
                        </button>
                        <div className="header-actions">
                            <button className="header-actions__btn" onClick={() => this.toggleMedicalInfo()}>
                                <i className="icon-medical-info"></i> <span className="btn__text">Questionnaire</span>
                            </button>
                            {!window.sdk.session().isExtern() && <button className="header-actions__btn" onClick={() => this.showModal('docs')}>
                                {count >0 && <span className="btn__notif">{count}</span>}
                                <i className="icon-docs"></i> <span className="btn__text">Fichiers patient</span>
                            </button> }
                            <button className="header-actions__btn" onClick={() => this.showModal('settings')}>
                                <i className="icon-settings"></i> <span className="btn__text">Réglages</span>
                            </button>
                            { <button className="header-actions__btn" onClick={this.toggleLogoutConfirm}>
                                <i className="icon-exit"></i> <span className="btn__text">Déconnexion</span>
                            </button> }
                        </div>
                    </React.Fragment>)}
                </div>
                {this.state.confirmLogout && <ModalConfirm title={"Voulez vous vous déconnecter et fermer l'application ?"} onConfirm={(e) => { this.logout() }} onCancel={this.toggleLogoutConfirm}></ModalConfirm>}
                {this.state.modal == 'docs' && <Modal close={true} variant="documents" onClose={() => this.showModal(false)}>
						<Documents />
				</Modal>}
                {this.state.modal == 'settings' && <Modal close={true} variant="settings" classname="main-settings-modal" onClose={() => this.showModal(false)}>
                    <Settings />
                </Modal>}
            </header>
        )
    }
}
